import React from "react";
import { ArrowRightAltRounded } from "@mui/icons-material";
import { Loader } from 'rsuite';

/**
 * Composant qui permet d'afficher des statistiques
 */

export default function StatisticsNumber({ title, secondTitle, status, firstData, secondData, pourcentage, mesure, active }) {
    const formatData = (data, mesure) => {
        if (mesure === "K" && data > 1000) {
            return (data / 1000).toFixed(1) + mesure;
        } else {
            return data;
        }
    };

    return (
        <div className="statistics-number">
            <div className="statistics-number-title">
                <h2>{title}</h2>
            </div>
            <div className="statistics-number-total">
                <p>{firstData !== null ? formatData(firstData, mesure) : '0'}{mesure !== 'K' ? mesure : ''}</p>
                {active ? (
                    <div className={status === 'stable' && pourcentage !== "--" ? 'stable' : status === 'baisse' ? 'baisse' : status === 'hausse' ? 'hausse' : ''}>
                        {pourcentage !== "--" && (
                            <span >
                                <ArrowRightAltRounded />
                            </span>
                        )}
                        {pourcentage}{pourcentage !== "--" && (<>%</>)}
                    </div>
                ) : (
                    <Loader />
                )}
            </div>
            <div className="statistics-number-description">
                <p>{secondTitle === '' ? '--' : secondTitle ? secondTitle : '--'}{formatData(secondData, mesure)}{mesure !== 'K' && secondData ? mesure : ''}</p>
            </div>
        </div>
    )
}